import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { QueryKeyConfig } from '../../../api/api-helper';
import useDebouncedValidation from '../../../hooks/use-debounced-hookform-validation';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { FormError } from '../../../components/hook-form/hook-form-error';

interface InputFieldProps {
  label?: string;
  placeHolder?: string;
  name: string;
  maxLength?: number;
  size?: number;
  multiline?: boolean;
  type?: string;
  isParentLoading?: boolean;
  autoFocus?: boolean;
  onChange?: any;
  disabled?: boolean;
  isShrink?: boolean;
  isValidateOnChange?: boolean;
  validationQueryRoute?: (value: any) => QueryKeyConfig;
  className?: string;
  required?: boolean;
}

export const FormInput = ({
  name,
  label,
  size,
  multiline,
  type,
  isParentLoading,
  onChange,
  disabled,
  isShrink,
  isValidateOnChange,
  validationQueryRoute,
  className,
  required,
}: InputFieldProps): any => {
  const { control, trigger } = useFormContext();
  const { validate, isLoading } = useDebouncedValidation({ name, validationQueryRoute });

  const [value, setValue] = useState('');

  const handleChange = (val: any) => {
    setValue(val);
    onChange(val);
    if (!isValidateOnChange) {
      validate(val);
    }
  };

  const handleOnBlur = (val: any) => {
    validate(val);
  };

  // useEffect(() => {
  //   // Only trigger validation if the field's value changes
  //   if (value !== '') {
  //     trigger(name); // This triggers the validation when the value changes
  //   }
  // }, [value, trigger, name]);

  return (
    <div className="form-group">
      <Controller
        control={control}
        name={name}
        rules={{
          required: required ? `${label} is required` : false, // Apply required validation if `required` is true
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <LoadingIndicator isLoading={isLoading || isParentLoading} />
            <TextField
              name={name}
              label={label}
              variant="outlined"
              size="small"
              fullWidth
              multiline={multiline}
              rows={size ? size : 4}
              onBlur={(e) => {
                //  onBlur(); validation disappearing on focus out
                handleOnBlur(e.target.value);
              }}
              onChange={(e) => {
                onChange(e);
                handleChange(e.target.value);
              }}
              type={type}
              value={value}
              disabled={disabled}
              InputLabelProps={{
                shrink: !isShrink ? undefined : isShrink,
              }}
              InputProps={{
                inputProps: {
                  min: 0,
                },
              }}
              className={`${className} ${required ? 'itsarequiredField' : ''} ${value ? 'has-data' : ''}`}
            />
          </>
        )}
      />
      <FormError name={name} />
    </div>
  );
};

FormInput.defaultProps = {
  label: undefined,
  maxLength: undefined,
  placeHolder: undefined,
  onChange: () => {
    return;
  },
};

export default FormInput;
